module.exports = __webpack_public_path__ + "img/skip-button.c8cf422c.png";